import EmblaCarousel from "embla-carousel";
import { initEmblaProgress, initEmblaNav } from '@theme/base';

class ProductRecommendations extends HTMLElement {
  async connectedCallback() {
    const viewportNode = this.querySelector(".embla__viewport_related");
    const container = this.querySelector(".embla_related");
    if (!viewportNode) return;
    
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set("product_id", this.dataset.productId);
    url.searchParams.set("intent", this.dataset.intent);
    url.searchParams.set("limit", this.dataset.limit);
    url.searchParams.set("section_id", "related-products");

    const show = () => {
      const wrapper = this.closest('.related-wrapper');
      if (wrapper) wrapper.classList.remove('hidden')
    };

    if (this.dataset.emblaInitialized) return;

    try {
      const res = await fetch(url.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (!res.ok) {
        console.warn("[ProductRecommendations] Fetch fallita:", res.status);
        return;
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      if (container) {
        container.innerHTML = doc.querySelector(".embla_related").innerHTML;
      }
    } catch (err) {
      console.error("[ProductRecommendations] Errore:", err);
    }

    const totalSlide = viewportNode.querySelectorAll(":scope .embla__slide").length;
    const cards = document.querySelectorAll(".embla__slide");

    if (totalSlide <= 1) {
      return;
    } else {
      show();
    }

    this.emblaApi = EmblaCarousel(viewportNode, {
      align: "start",
      watchDrag: (emblaRoot, event) => {
        return !event.target.closest('.embla-internal');
      }
    });

    const prevBtn = this.querySelector('.embla__prev');
    const nextBtn = this.querySelector('.embla__next');

    if (prevBtn) {
      initEmblaNav(prevBtn, this.emblaApi);
    }
    if (nextBtn) {
      initEmblaNav(nextBtn, this.emblaApi, true);
    }

    const progress = this.closest('.shopify-section').querySelector('.main-progress');
    if (progress) {
      initEmblaProgress(viewportNode, this.emblaApi, progress);
    }

    this.emblaApi.on("pointerDown", () => {
      cards.forEach((card) => {
        const api = card.emblaApi;
        if (api) {
          api.reInit({ draggable: false });
        }
      });
    });

    this.emblaApi.on("pointerUp", () => {
      cards.forEach((card) => {
        const api = card.emblaApi;
        if (api) {
          api.reInit({ draggable: true });
        }
      });
    });

    this.dataset.emblaInitialized = "true";
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}